import React, { useEffect, useRef, useState } from 'react'
import { useFetching } from '../hooks/useFetching'
import OperationModeService from '../api/OperationModeService'
import { Controller, useForm } from 'react-hook-form';
import DatePicker from '../components/ui/DatePicker';
import Select from '../components/ui/Select';
import Button from '../components/ui/Button'
import { formatDate } from '../utils/date';


const AdminPage = () => {
  const [currentOperationMode, setCurrentOperationMode] = useState(null)
  const [operationModes, setOperationModes] = useState([])
  const [operationModesForSelect, setOperationModesForSelect] = useState([])

  const datePickerBeginDateRef = useRef(null)
  const datePickerEndDateRef = useRef(null)

  const [getOperationModes, isModesLoading, modesErr] = useFetching(async () => {
    const response = await OperationModeService.getOperationModes()
    const modes = response.data
    const currentMode = modes.find(m => m.isActive == true)
    setCurrentOperationMode(currentMode)
    
    let modesForSelect = []
    for (let i = 0; i < modes.length; i++) {
      const mode = modes[i]
      modesForSelect.push({
        value: mode.id,
        label: mode.name,
        customProperties: {
          beginDate: mode.beginDate,
          endDate: mode.endDate,
        }
      })
    }
    setOperationModesForSelect(modesForSelect)
    setOperationModes(modes)
    resetChange({
      operationModeId: currentMode.id
    })

    if (currentMode.beginDate != null && currentMode.endDate != null) {
      resetUpdate({
        operationModeId: currentMode.id,
        beginDate: new Date(currentMode.beginDate),
        endDate: new Date(currentMode.endDate)
      })
      datePickerBeginDateRef.current.setSelected(new Date(currentMode.beginDate))
      datePickerEndDateRef.current.setSelected(new Date(currentMode.endDate))
    }
  })

  const [changeOperationMode, isChangeLoading, changeErr] = useFetching(async (operationModeId) => {
    const response = await OperationModeService.changeOperationMode(operationModeId)
    if (response.status == 200) {
      alert("Режим работы успешно изменен!")
      setCurrentOperationMode(operationModes.find(m => m.id == operationModeId))
    }
  })

  const [updateOperationMode, isUpdateLoading, updateErr] = useFetching(async (mode) => {
    const response = await OperationModeService.updateOperationMode(mode)
    if (response.status == 200) {
      alert("Промежуток времени успешно изменен!")
    }
  })

  useEffect(() => {
    getOperationModes()
  }, [])

  const { control: controlChange, handleSubmit: handleSubmitChange, reset: resetChange } = useForm({
    mode: "onSubmit"
  })

  const { control: controlUpdate, handleSubmit: handleSubmitUpdate, reset: resetUpdate } = useForm({
    mode: "onSubmit",
  })

  const onChangeMode = (data) => {
    changeOperationMode(data.operationModeId)
  } 

  const changeDateIntervalByModeId = (modeId) => {
    const mode = operationModes.find(m => m.id == modeId)
    datePickerBeginDateRef.current.setSelected(new Date(mode.beginDate))
    datePickerEndDateRef.current.setSelected(new Date(mode.endDate))
  }

  const onUpdateMode = (data) => {
    data.beginDate = datePickerBeginDateRef.current.props.selected
    data.endDate = datePickerEndDateRef.current.props.selected

    const modeUpdated = operationModes.find(m => m.id == data.operationModeId)
    modeUpdated.beginDate = data.beginDate
    modeUpdated.endDate = data.endDate

    updateOperationMode(modeUpdated)
  }

  return (
    <div className='admin-page'>
      <div className="container">
        <h1 className="admin-page__title title">Личный кабинет администратора</h1>
        <div className="admin-page__mode-block block-mode">
          <div className="block-mode__current">
            <div className="block-mode__current-mode">Текущий режим работы: <strong>{currentOperationMode?.name}</strong></div>
            {
              (currentOperationMode?.beginDate != null && currentOperationMode?.endDate != null) &&
              <div className='block-mode__current-interval'>Промежуток времени: {formatDate(new Date(currentOperationMode?.beginDate))} - {formatDate(new Date(currentOperationMode?.endDate))}</div>
            }
          </div>
          <div className="block-mode__change-mode mode-change">
            <h2 className="mode-change__title title">Изменение режима работы анкетирования</h2>
            <form className='form' onSubmit={handleSubmitChange(onChangeMode)}>
              <label className='form__label'>
                <span className='form__text'>Режим работы</span>
                <Controller
                  control={controlChange}
                  name='operationModeId'
                  rules={{
                    required: true
                  }}
                  render={({ field: { value, onChange }, fieldState: { error } }) => (
                    <div className={error ? 'error' : ''}>
                      <Select
                        value={
                          operationModesForSelect?.find(m => m.value == value)
                        }
                        onChange={(newValue) => { onChange(newValue.value) }}
                        placeholder='Выберите режим работы'
                        options={operationModesForSelect}
                        isLoading={isModesLoading}
                        isDisabled={isModesLoading}
                      />
                    </div>
                  )}
                />
              </label>
              <Button className={`form__btn btn${isChangeLoading ? " disable" : ""}`} disabled={isChangeLoading}>
                {isChangeLoading ? "Сохранение..." : "Сохранить"}
              </Button>
            </form>
          </div>
          <div className="block-mode__update-mode mode-update">
            <h2 className="mode-update__title title">Изменение промежутка времени режима работы анкетирования</h2>
            <form className='form' onSubmit={handleSubmitUpdate(onUpdateMode)}>
              <label className='form__label'>
                <span className='form__text'>Режим работы</span>
                <Controller
                  control={controlUpdate}
                  name='operationModeId'
                  rules={{
                    required: true
                  }}
                  render={({ field: { value, onChange }, fieldState: { error } }) => (
                    <div className={error ? 'error' : ''}>
                      <Select
                        value={
                          operationModesForSelect?.find(m => m.value == value)
                        }
                        onChange={(newValue) => {
                          changeDateIntervalByModeId(newValue.value);
                          onChange(newValue.value) 
                        }}
                        placeholder='Выберите режим работы'
                        options={operationModesForSelect.filter(m => m.customProperties.beginDate != null && m.customProperties.endDate != null)}
                        isLoading={isModesLoading}
                        isDisabled={isModesLoading}
                      />
                    </div>
                  )}
                />
              </label>
              <div className="form__time-interval">
                <label className='form__label' onClick={(evt) => evt.preventDefault()}>
                  <span className='form__text'>Дата начала</span>
                  <Controller
                    control={controlUpdate}
                    name='beginDate'
                    render={({ field: { onChange } }) => (
                      <div>
                        <DatePicker
                          ref={datePickerBeginDateRef}
                          onChange={(newDate) => onChange(newDate)}
                        />
                      </div>
                    )}
                  />
                </label>
                <label className='form__label' onClick={(evt) => evt.preventDefault()} >
                  <span className='form__text'>Дата конца</span>
                  <Controller
                    control={controlUpdate}
                    name='endDate'
                    render={({ field: { onChange } }) => (
                      <div>
                        <DatePicker
                          ref={datePickerEndDateRef}
                          onChange={(newDate) => onChange(newDate)}
                        />
                      </div>
                    )}
                  />
                </label>
              </div>
              <Button className={`form__btn btn${isUpdateLoading ? " disable" : ""}`} disabled={isUpdateLoading}>
                {isUpdateLoading ? "Сохранение..." : "Сохранить"}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminPage